import { render, staticRenderFns } from "./BehaviorLog.vue?vue&type=template&id=18742329"
import script from "./BehaviorLog.vue?vue&type=script&lang=js"
export * from "./BehaviorLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports